import { render } from "./SeleccionGenero.vue?vue&type=template&id=57c77020&scoped=true"
import script from "./SeleccionGenero.vue?vue&type=script&lang=js"
export * from "./SeleccionGenero.vue?vue&type=script&lang=js"

import "./SeleccionGenero.vue?vue&type=style&index=0&id=57c77020&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c77020"]])

export default __exports__